import { Box, CircularProgress } from "@mui/material";
import { useEffect, useState, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { myStore } from "../..";
import { axiosInstance } from "../../Axios";
import { tokenConfig } from "../../store/reducers/tokenReducer";
import PayoutCertificates from "./PayoutCertificates";
import Stage1Certificate from "./Stage1Certificate/Stage1Certificate";
import Stage2Certificate from "./Stage2Certificate/Stage2Certificate";
import FundedCertificate from "./FundedCertificate/FundedCertificate";
import { ReactComponent as UncheckedCheckbox } from "../../assets/icons/NewIcons/uncheckedCheckbox.svg";
import { ReactComponent as CheckedCheckbox } from "../../assets/icons/NewIcons/checkedCheckboxWhite.svg";
import "./style.scss";
import LifetimeCertificates from "./Lifetime";
import Loader from "../../reusableComponents/Loader";
import MaxAllocationCert from "./MaxAllocationCert/MaxAllocationCert";

const Certificates = () => {
  const ACCtoken = useSelector((state) => state.ACCtoken);
  const [certificate, setCertificate] = useState([]);
  const [loading, setLoading] = useState(true); // State to track loading status
  const [selectedFilter, setSelectedFilter] = useState("All Certificates");
  const [openFilter, setOpenFilter] = useState(false);

  const fetchCertificatess = () => {
    setLoading(true); // Set loading to true when fetching data
    axiosInstance
      .get("v2/achievements/certificates/list/", tokenConfig(myStore.getState))
      .then((response) => {
        const certificateData = response.data;
        setCertificate(certificateData);
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((error) => {
        console.log(error);
        setLoading(false); // Set loading to false if there's an error
      });
  };
  useEffect(() => {
    fetchCertificatess();
  }, [ACCtoken]);

  const handleFilterToggle = (filter) => {
    setSelectedFilter(filter);
    setOpenFilter(false);
  };

  const filteredCertificates = useMemo(() => {
    if (!certificate || certificate.length === 0) return [];

    switch (selectedFilter) {
      case "Payout Split":
        return certificate.filter((item) => item.type === "Profit Split");
      case "Lifetime Payout":
        return certificate.filter((item) => item.type === "Lifetime Payout");
      case "Stage 1":
        return certificate.filter((item) => item.type === "Stage 1 Pass");
      case "Stage 2":
        return certificate.filter((item) => item.type === "Stage 2 Pass");
      case "Funded Profit":
        return certificate.filter((item) => item.type === "Funded Profit");
      case "All Certificates":
      default:
        return certificate;
    }
  }, [selectedFilter, certificate]);

  const renderCertificateComponent = (item) => {
    switch (item.type) {
      case "Profit Split":
        return (
          <PayoutCertificates
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
          />
        );
      case "Lifetime Payout":
        return (
          <LifetimeCertificates
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
          />
        );
      case "Stage 1 Pass":
        return item.plan_type === "Alpha One" ? (
          <FundedCertificate
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
          />
        ) : (
          <FundedCertificate
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
            image={true}
          />
        );
      case "Stage 2 Pass":
        return (
          <Stage2Certificate
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
          />
        );
      case "Qualified":
        return (
          <FundedCertificate
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
          />
        );
      case "Max Allocation":
        return (
          <MaxAllocationCert
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
          />
        );

      case "Funded Profit":
        return (
          <FundedCertificate
            fetchCertificatess={fetchCertificatess}
            key={item.id}
            data={item}
          />
        );
      default:
        return null;
    }
  };
  const filterRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setOpenFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="all_certificates_wrapper">
      {/* Filter Button */}
      <div className="filter_container" ref={filterRef}>
        <div
          onClick={() => setOpenFilter(!openFilter)}
          className="certificate_filter_wrapper"
        >
          Filters
        </div>

        {/* Filter Menu */}
        {openFilter && (
          <div className="filterItems">
            {[
              "All Certificates",
              "Lifetime Payout",
              "Payout Split",
              "Stage 1",
              "Stage 2",
              "Funded Profit",
            ].map((filter) => (
              <div
                key={filter}
                className={`filterItem ${
                  selectedFilter === filter ? "checked" : ""
                }`}
                onClick={() => handleFilterToggle(filter)}
                style={{ cursor: "pointer" }}
              >
                {selectedFilter === filter ? (
                  <CheckedCheckbox className="checked" />
                ) : (
                  <UncheckedCheckbox />
                )}
                <span>
                  {filter?.replace("Funded Profit", "Performance Fees")}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div
        className={`${
          filteredCertificates.length > 2 ? "certificates" : "certificates_low"
        }`}
      >
        {loading ? (
          <Loader open={loading} />
        ) : filteredCertificates.length > 0 ? (
          filteredCertificates.map((item) => renderCertificateComponent(item))
        ) : (
          <p>No certificates found.</p>
        )}
      </div>
    </div>
  );
};

export default Certificates;
